
<template>
    <span>
        <span v-show="value">
            <fa-icon icon="circle-check" />
        </span>
        <span v-show="!value">
            <fa-icon icon="circle-xmark" />
        </span>
    </span>
</template>

<style scoped lang="scss">
    svg.fa-circle-check {
        color: green;
    }
    svg.fa-circle-xmark {
        color: red;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "BoolDisplay",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    }
});

</script>
